import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import cn from 'classnames'

import slice from 'lodash/slice'
import values from 'lodash/values'
import { isEmpty } from 'lodash'

const isLandscape = window.matchMedia('(min-width: 1081px')
const DONE_ORDERS_SLOTS = isLandscape.matches ? 10 : 6

const OrdersDoneList = ({ ordersDone, orderWindowNames, currentRevenueCenterName }) => {
  const isWindowPickUp = values(orderWindowNames).some((orderWindow) => !isEmpty(orderWindow))
  const orderNumberAllFourDigits = !ordersDone.find((order) => order.order.length > 4)
  const portraitOrdersToDisplay = orderNumberAllFourDigits ? 10 : 6
  const renderNumberOrdersToDisplay = () =>
    isWindowPickUp ? DONE_ORDERS_SLOTS : !isLandscape.matches ? portraitOrdersToDisplay : 10
  const isManyOrders = ordersDone.length > renderNumberOrdersToDisplay()
  const isPortraitWithLongOrderNumbers = !isLandscape.matches && renderNumberOrdersToDisplay() === 6

  const orders =
    ordersDone.length > renderNumberOrdersToDisplay()
      ? slice(ordersDone, 0, renderNumberOrdersToDisplay() - 1)
      : ordersDone

  const moreOrdersNumber = `+${ordersDone.length - orders.length} more`

  return (
    <section className="orders-done">
      <header>
        <Link to="/revenueCenters">
          <h3 className="orders-done__header">
            <span className="orders-done__rvc-name">{`${currentRevenueCenterName}: `}</span>
            &nbsp;Ready For Pickup
          </h3>
        </Link>
      </header>
      {isWindowPickUp ? (
        <ul className="orders-done__list">
          {orders.map((item) => {
            const windowOpenName = orderWindowNames?.[item.order] ?? ''
            return (
              <li className="orders-done__item" key={item.order}>
                <div className={cn('orders-done__item-order-wrapper', { '-new': item.isNew })}>
                  <span className="orders-done__item-order-number">{`${item.order}`}</span>
                  <span className="orders-done__item-order-window">
                    {windowOpenName.slice(0, 1)}
                  </span>
                </div>
              </li>
            )
          })}
          {isManyOrders && <li className="orders-done__item -more">{moreOrdersNumber}</li>}
        </ul>
      ) : (
        <ul className="orders-done__list">
          {orders.map((item) => {
            return (
              <li className="orders-done__item -noWindowPickup" key={item.order}>
                <div className={cn('orders-done__item-order-wrapper', { '-new': item.isNew })}>
                  <span className="orders-done__item-order-number">{`${item.order}`}</span>
                </div>
              </li>
            )
          })}
          {isManyOrders && (
            <li
              className={cn('orders-done__item -more -noWindowPickup', {
                '-columnOrderInPortrait': isPortraitWithLongOrderNumbers,
              })}
            >
              {moreOrdersNumber}
            </li>
          )}
        </ul>
      )}
    </section>
  )
}

OrdersDoneList.propTypes = {
  ordersDone: PropTypes.array,
  currentRevenueCenterName: PropTypes.string,
  orderWindowNames: PropTypes.object,
}

export default OrdersDoneList
